module.exports = __webpack_public_path__ + "account/assets/oops-rhino-in-a-hat.d662a686.svg";